import { lazy } from "react";
import { Navigate } from "react-router";
import DepositWallet from "src/pages/user/financial/deposit";
import Ewallet from "src/pages/user/financial/ewallet";
import FundTransfer from "src/pages/user/financial/fundTransfer";
import Loadable from "../Loadable";

const AddCredit = Loadable(
  lazy(() => import("src/pages/user/financial/deposit/addCredit"))
);

const RequestPayout = Loadable(
  lazy(() => import("src/pages/user/financial/requestPayout/index"))
);
const PendingWallet = Loadable(
  lazy(() => import("src/pages/user/financial/pending/index"))
);
const EduPointWallet = Loadable(
  lazy(() => import("src/pages/user/financial/edu-point-wallet/index"))
);
const UpWallet = Loadable(
  lazy(() => import("src/pages/user/financial/up-wallet/index"))
);

const financial = {
  path: "financial",
  children: [
    { index: true, element: <Navigate to="e-wallet" /> },
    { path: "e-wallet", element: <Ewallet /> },
    {
      path: "deposit-wallet",
      children: [
        { index: true, element: <DepositWallet /> },
        { path: "add-credit", element: <AddCredit /> },
      ],
    },
    { path: "pending-wallet", element: <PendingWallet /> },
    { path: "edu-point-wallet", element: <EduPointWallet /> },
    { path: "up-wallet", element: <UpWallet /> },
    { path: "funds-transfer", element: <FundTransfer /> },
    { path: "payout", element: <RequestPayout /> },
  ],
};

export default financial;
